import { Link } from 'react-router-dom';
import Logo from '@/components/Logo';

export default function NotFound() {
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center px-6 pt-[120px] text-center" data-testid="not-found">
      <Logo />
      <p className="mt-10 font-mono text-6xl font-bold text-brand-cyan">404</p>
      <p className="mt-3 max-w-sm text-[15px] text-brand-muted">Página não encontrada · Página no encontrada · Page not found</p>
      <Link to="/pt-br" data-testid="not-found-home-link" className="mt-8 rounded-full bg-brand-blue px-7 py-3 text-sm font-semibold text-white transition hover:bg-brand-bluedark">
        Início · Inicio · Home
      </Link>
    </div>
  );
}